export default function AddressIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={`address-icon ${className}`}
      onClick={onClick}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M402.94,182.09c0-4.32-2.15-8.31-5.76-10.7l-140.08-92.59c-2.15-1.42-4.61-2.13-7.08-2.13s-4.83.68-6.94,2.04l-140.19,90.09c-3.69,2.37-5.9,6.41-5.9,10.8l.05,230.9c0,7.07,5.76,12.83,12.84,12.83h280.28c3.43,0,6.66-1.33,9.08-3.76,2.43-2.43,3.76-5.66,3.76-9.08l-.06-228.39ZM278.41,397.65h-56.75v-114.62h56.75v114.62ZM304.08,397.65v-127.45c0-7.08-5.76-12.84-12.84-12.84h-82.42c-7.08,0-12.84,5.76-12.84,12.84v127.45h-73.26l-.05-211.05,127.25-81.77,127.36,84.17.05,208.65h-73.25Z"
      />
    </svg>
  );
}
